module.exports = __webpack_public_path__ + "img/logout.647a5a33.svg";